import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'individuals_responsible_for_implementation_3'

export const dataPointDefinition = {
  retracedId: 'individuals_responsible_for_implementation_3',
  name: 'Individuals responsible for implementation',
  description:
    'Individuals responsible for implementation may include human resources managers, operations managers, sourcing managers, line or shift supervisors, health and safety personnel, janitorial staff, security guards or other positions.',
  meta: {
    slcpMeta: {
      key: 'ms-5--4-3x',
      number: 'MS-DO-10-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'ms-do-39',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[3],ms-5--1-2x',
      machineShowHide: '[3],ms-5--1-2x',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-5--4-3x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32910,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
